export default {
    data() {
        return {
            disabled: false
        }
    },
    mounted() {
        this.emitter.on('toggleDisabled', data => {
            this.disabled = !this.disabled;
        });
    },
    computed: {
        continueText() {
            return 'Continue to ' + (this.basket.home_delivery == true || (this.basket.route.includes('fitted-nationally')) ? 'Checkout' : 'Fitters');
        },
        basketTyres() {
            let tyres = this.basket.products.filter((basket_product) => {
                return (basket_product.product_type == 'product');
            });

            return tyres;
        },
        basketServices() {
            let services = this.basket.products.filter((basket_product) => {
                return (basket_product.product_type == 'service');
            });

            return services;
        }
    }
}